import { AutogenLayoutOfficePayrollProfileFilter } from "./autogen/AutogenLayoutOfficePayrollProfileFilter";

export class OfficePayrollProfileFilter extends AutogenLayoutOfficePayrollProfileFilter {
    onLoad(): void | Promise<void> {
        this.layoutProfile.textboxDescr.enabled = false;
        this.layoutProfile.layoutProfileColor.visible = false;
    }
}
